import React, { lazy, Suspense, useState, useEffect, useRef } from "react";
import { Spinner } from "react-bootstrap";
import "../Body/Body.css";
import Banner from "../Banner";

const OurNiches = lazy(() => import('../OurNiches/OurNiches'));
const AngelAi = lazy(() => import('../AngelAI/AngelAI'));
const LOVideos = lazy(() => import('../LOVideos/LOVideos'));
const Footer = lazy(() => import("../Footer/index"));

export default function Body() {
  const [showOtherComponents, setShowOtherComponents] = useState(false);
  const animationRef = useRef(null);

  // Individual gradient configurations with separate refs
  const gradients = [
    {
      id: 1,
      ref: useRef(null),
      className: 'gradient-1',
      speedX: 0.3,
      speedY: 0.4,
      rangeX: 80,
      rangeY: 70,
      offsetX: 10,
      offsetY: 15
    },
    {
      id: 2,
      ref: useRef(null),
      className: 'gradient-2',
      speedX: -0.25,
      speedY: 0.35,
      rangeX: 75,
      rangeY: 60,
      offsetX: 15,
      offsetY: 20
    },
    {
      id: 3,
      ref: useRef(null),
      className: 'gradient-3',
      speedX: 0.4,
      speedY: -0.3,
      rangeX: 85,
      rangeY: 80,
      offsetX: 5,
      offsetY: 10
    },
    {
      id: 4,
      ref: useRef(null),
      className: 'gradient-4',
      speedX: -0.35,
      speedY: 0.45,
      rangeX: 70,
      rangeY: 75,
      offsetX: 20,
      offsetY: 5
    },
    {
      id: 5,
      ref: useRef(null),
      className: 'gradient-5',
      speedX: 0.2,
      speedY: -0.38,
      rangeX: 90,
      rangeY: 65,
      offsetX: 0,
      offsetY: 25
    }
  ];

  // Animation loop
  useEffect(() => {
    let startTime = Date.now();

    const animate = () => {
      const currentTime = Date.now();
      const elapsed = (currentTime - startTime) * 0.001;

      gradients.forEach((gradient) => {
        if (gradient.ref.current) {
          const moveX = gradient.offsetX + (Math.sin(elapsed * gradient.speedX) + 1) * gradient.rangeX / 2;
          const moveY = gradient.offsetY + (Math.cos(elapsed * gradient.speedY) + 1) * gradient.rangeY / 2;

          const rotation = Math.sin(elapsed * gradient.speedX * 0.5) * 20;
          const scale = 0.7 + Math.sin(elapsed * gradient.speedY * 0.4) * 0.4;
          const opacity = 0.6 + Math.sin(elapsed * gradient.speedX * 0.6) * 0.3;

          const element = gradient.ref.current;
          element.style.left = `${moveX}%`;
          element.style.top = `${moveY}%`;
          element.style.transform = `translate(-50%, -50%) rotate(${rotation}deg) scale(${scale})`;
          element.style.opacity = Math.max(0.2, Math.min(0.5, opacity));
        }
      });

      animationRef.current = requestAnimationFrame(animate);
    };

    animate();

    return () => {
      if (animationRef.current) {
        cancelAnimationFrame(animationRef.current);
      }
    };
  }, []);

  useEffect(() => {
    const handleScroll = () => {
      const windowHeight = window.innerHeight;
      const documentHeight = document.body.offsetHeight;
      const scrollPosition =
        window.scrollY ||
        window.pageYOffset ||
        document.documentElement.scrollTop;
      const maxScroll = documentHeight - windowHeight;
      const percentage = (scrollPosition / maxScroll) * 100;

      if (percentage > 20) {
        setShowOtherComponents(true);
      }
    };

    window.addEventListener("scroll", handleScroll);

    // Clean up the scroll listener when the component unmounts
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);
  return (
    <div>
      <Banner />
      <div className="body-gradient-container">
        {gradients.map((gradient) => (
          <div
            key={gradient.id}
            ref={gradient.ref}
            className={`body-gradient-element ${gradient.className}`}
          />
        ))}
        <Suspense fallback={<Spinner />}>
          <OurNiches />
        </Suspense>
        {showOtherComponents ? (
          <>
            <Suspense fallback={<Spinner />}>
              <LOVideos />
              <Suspense fallback={<Spinner />}>
                <AngelAi />
                <Suspense fallback={<div>Loading...</div>}>
                  <div className="terms-footer">
                    <Footer />
                  </div>
                </Suspense>
              </Suspense>
            </Suspense>
          </>
        ) : (
          ""
        )}

      </div>
    </div>
  );
}
